import { GetterTree, Getter } from "vuex";
import { SiteMonitorState, EventShareUser } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<SiteMonitorState, RootState> = {
	getLastActivity: state => state.LastActivity,
	getEventDetails: state => state.EventDetails,
	getEventLocationLastSet: state => state.eventLocationLastSet,
	getRequestingEventRecords: state => state.requestingEventRecords,
	getEventRecords: state => state.EventRecords,
	getEventRecordsAwaitingAckCount: state => state.EventRecordsAwaitingAckCount,
	getEventRecordsAwaitingRestoreCount: state => state.EventRecordsAwaitingRestoreCount,
	getEventRecordsWithFiles: state => state.EventRecordsWithFiles,
	getActiveResponseIDs: state => state.ActiveResponseIDs,
	getEventRecordFilters: state => state.EventRecordFilters,
	getCurrentRecordFilter: state => {
		if (state.EventRecordsFilterActiveIndex === -1) {
			return null;
		}

		return state.EventRecordFilters[state.EventRecordsFilterActiveIndex];
	},
	getEventRecordsNoFilterRenderIndex: state => state.EventRecordsNoFilterRenderIndex,
	getFilteredRecords: state => {
		if (state.EventRecordsFilterActiveIndex === -1) {
			return state.EventRecords;
		}

		const activeFilter = state.EventRecordFilters[state.EventRecordsFilterActiveIndex];
		return state.EventRecords.filter(
			(record: any) => activeFilter.filterRecordIds.indexOf(record.eventRecordTypeID) > -1
		);
	},
	getLatestEventRecord: state => state.LatestEventRecordID,
	getEventCloseShown: state => state.EventCloseOpen,
	getEventDetailsShown: state => state.EventDetailsOpen,
	getEventRaiseShown: state => state.EventRaiseOpen,
	getIncidentReportShown: state => state.IncidentReportOpen,
	getIncidentReportDownloaded: state => state.IncidentReportDownloaded,
	getEventShareShown: state => state.EventSharingOpen,
	getEventLeaveShown: state => state.EventLeaveOpen,
	getPutEventOnTestShown: state => state.PutEventOnTestOpen,
	getEventShare: state => state.EventShares,
	getEventShareSet: state => state.EventSharesSet,
	getEventNoPermission: state => state.EventNoPermission,
	userShares: (state, storeGetters) => {
		const shares: { [key: string]: EventShareUser } = {};
		storeGetters.getEventShare.forEach((user: EventShareUser) => {
			shares[user.eventUserID] = {
				isController: user.userID === state.ControllerUserID,
				...user
			};
		});

		return shares;
	},
	shareWithPersons: state => state.ShareWithPersons,
	getExternalUsersAllowed: state => state.ExternalUsersAllowed,
	getAdhocShareDetails: state => (eventUserId: string) => state.AdhocShareDetails[eventUserId],
	groupID: state => state.GroupID,
	getSelectedEventRecord: state => state.SelectedEventRecord,
	getActiveMapItems: state => state.activeMapItems,
	getMapCircleCenter: state => state.mapCircleCenter,
	getIsController: state => state.IsController,
	getUserID: state => state.UserID,
	filterIndex: state => state.EventRecordsFilterActiveIndex,
	getDispatchedGuard: state => state.DispatchedGuard,
	getAuditService: state => state.auditService,
	getMaskReasons: state => state.MaskReasons,
	getEvents: state => state.Events,
	getGroupMaskReasons: state => state.GroupMaskReasons,
	maskedAlarms: state => state.MaskedAlarms,
	getEventOperators: state => state.EventShares,
	areaNotesVisible: state => state.AreaNotesVisible,
	getForceRestoreEventRecord: state => state.ForceRestoreEventRecord,
	getActiveMapItemsRequired: state => state.ActiveMapItemsRequired,
	getIsUploadingFile: state => state.IsUploadingFile,
	getHideMapFlag: state => state.hideMapFlag,
	requiredMapPinIcon: (state): boolean => {
		if (!state.EventRecords || !state.EventDetails) {
			return false;
		}

		return (
			state.EventRecords &&
			state.EventRecords.length > 0 &&
			!state.EventRecords[0].location &&
			state.EventDetails.mapPinIcon
		);
	},
	eventOutcomesTree: state => state.eventOutcomes.eventOutcomeTree,
	eventOutcomesFlatList: state => state.eventOutcomes.eventOutcomeFlatList,
};
